import React from 'react';
import { bonusItems } from '../data/bonuses';
export function BonusPackSection() {
  return <section aria-labelledby="bonos-title" className="bg-cream-deep" data-id="element-21" data-mp="3nrh8z8rryh2h">
      <div className="mx-auto max-w-3xl px-5 py-20 lg:py-24" data-id="element-22" data-mp="3npcy26vgkhsp">
        <h2 id="bonos-title" className="text-center font-display text-3xl font-black leading-tight text-ink sm:text-4xl" data-id="element-23" data-mp="3sjqveetokz00">
          <span aria-hidden="true" data-id="element-24" data-mp="1bd6a472wf6l">🎁 </span>3 Bonos exclusivos
        </h2>
        <p className="mt-3 text-center text-sm text-muted" data-id="element-25" data-mp="30sl32kk7c5la">
          Valor total <span className="font-semibold text-coral line-through" data-id="element-26" data-mp="34sbtgn5tgjpa">$37000</span> — Incluido hoy{' '}
          <span className="font-bold text-coral" data-id="element-27" data-mp="39reulwioe5rz">GRATIS</span> en el precio
        </p>

        <ol className="mt-10 space-y-5" data-id="element-28" data-mp="3eqrlqtgkxz0d">
          {bonusItems.map((bonus, index) => <li key={bonus.title} className="relative rounded-2xl bg-white px-5 py-6 sm:px-8" data-id="element-29" data-mp="3eookfd9z8jgc" data-mpi={index}>
              <span aria-hidden="true" className="absolute left-3 top-3 flex h-7 w-7 items-center justify-center rounded-full bg-coral text-xs font-bold text-cream sm:-left-3 sm:top-1/2 sm:-translate-y-1/2" data-id="element-30" data-mp="p43cdwsaw48y">
                {index + 1}
              </span>

              <div className="flex flex-col items-center gap-5 sm:flex-row sm:gap-7" data-id="element-31" data-mp="15de53wzdl55z">
                <img src={bonus.image} alt={`Portada del bono ${bonus.title}`} className="h-36 w-28 shrink-0 object-contain" data-id="element-32" data-mp="10c6ttny0xnuk" />
                <div className="text-center sm:text-left" data-id="element-33" data-mp="vddfjtawxstc">
                  <h3 className="font-display text-lg font-bold leading-snug text-ink" data-id="element-34" data-mp="qfc1jmscgjoq">{bonus.title}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-muted" data-id="element-35" data-mp="lntx2or440z0">{bonus.body}</p>
                  <p className="mt-2 text-xs font-bold uppercase tracking-[0.08em] text-coral" data-id="element-36" data-mp="hlyxbootxvnc">
                    <span className="line-through" data-id="element-37" data-mp="cnxglaevm8f1">valor {bonus.value}</span> GRATIS
                  </p>
                </div>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}